'use client';

import dynamic from 'next/dynamic';
import { memo } from 'react';

import { Modal, ModalProps } from '../Modal';
import { Loader } from '../profile/LoaderWrapper';
import { useDialogs, useDialogsPreloading } from './hooks';
import { Modals } from '@/helpers/modals';

const PRELOADED_MODALS = [Modals.Registration, Modals.Login];

interface DialogComponentProps {
  hideCrossClose?: boolean;
}

interface DialogsProps {
  containerProps?: ModalProps;
  componentProps?: DialogComponentProps;
}

export const Dialogs: React.FC<DialogsProps> = memo(
  ({ containerProps, componentProps }) => {
    const { modal } = useDialogs();
    const modalsCache =
      useDialogsPreloading<DialogComponentProps>(PRELOADED_MODALS);

    if (modal) {
      if (!modalsCache.has(modal)) {
        modalsCache.set(
          modal,
          dynamic<DialogComponentProps>(
            () => import(`@/components/dialogs/${modal}`),
            {
              ssr: false,
              loading: () => <Loader size={50} />,
            }
          )
        );
      }

      const Component = modalsCache.get(modal)!;

      return (
        <Modal {...containerProps}>
          <Component {...componentProps} />
        </Modal>
      );
    }
    return null;
  }
);
